import { render, staticRenderFns } from "./FormAssetTags.vue?vue&type=template&id=866734e4&lang=pug"
import script from "./FormAssetTags.vue?vue&type=script&lang=js"
export * from "./FormAssetTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports